export const LOGIN_PATH_PREFIXES = [
  '/login',
  '/tid/redirect',
  '/tid/logout',
  '/promo',
];
